import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container } from "./styles";
import "./Converter.css";

import { EracheToDateIRL, ParseEracheDateFromText, EracheMonths, formatIrlDateTime } from "../utils/dateConverters";
import { TextField, Select, FormControl, MenuItem, InputLabel } from "@mui/material";

const EracheToIRLConverter = () => {
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(1); // 1-based
  const [day, setDay] = useState(1);
  const [freeText, setFreeText] = useState("");
  const [irlDate, setIrlDate] = useState("");
  const [, setCopySuccess] = useState(false);
  const [buttonColor, setButtonColor] = useState("var(--accent)");
  const [buttonText, setButtonText] = useState("Copier");

  useEffect(() => {
    updateResult(year, month, day);
    // eslint-disable-next-line
  }, [year, month, day]);

  const updateResult = (year, month, day) => {
    const date = EracheToDateIRL(Number(year), Number(month), Number(day));
    if (isNaN(date.getTime())) {
      setIrlDate("Date invalide");
    } else {
      // Local time only (no UTC) to avoid 1h shift; international YYYY-MM-DD HH:mm
      setIrlDate(formatIrlDateTime(date));
    }
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(irlDate)
      .then(() => {
        setCopySuccess(true);
        setButtonText("Copié!");
        setButtonColor("var(--accent-hover)");
        setTimeout(() => {
          setCopySuccess(false);
          setButtonColor("var(--accent)");
          setButtonText("Copier");
        }, 2000);
      })
      .catch((error) =>
        console.error("Erreur lors de la copie dans le presse-papiers :", error)
      );
  };

  const handleFreeTextChange = (text) => {
    const parsed = ParseEracheDateFromText(text);
    if (parsed) {
      setDay(parsed.day);
      setMonth(parsed.month);
      setYear(parsed.year);
    }
  };

  return (
    <Container>
      <h1>Convertisseur Erache → IRL</h1>
      <ConverterContainer>
      <InputRow>
  <TextField
    label="Date érachienne (texte libre)"
    value={freeText}
    onChange={e => {
      setFreeText(e.target.value);
      handleFreeTextChange(e.target.value);
    }}
    placeholder="Ex: Le 12 Pampélune de l'an de grâce 3"
    size="small"
    sx={{ minWidth: 400 }}
  />
  <span 
    style={{ 
      margin: '0 12px', 
      fontWeight: 'bold', 
      fontSize: '24px',
      alignSelf: 'center', 
      height: '100%', 
      display: 'flex', 
      alignItems: 'center' 
    }}
  >
    /
  </span>
  <FormControl size="small" sx={{ minWidth: 100 }}>
    <TextField
      label="Jour"
      type="number"
      inputProps={{ min: 1, max: 64 }}
      value={day}
      onChange={e => setDay(e.target.value)}
      size="small"
    />
  </FormControl>
  <FormControl size="small" sx={{ minWidth: 120 }}>
    <InputLabel id="month-label">Mois</InputLabel>
    <Select
      labelId="month-label"
      value={month}
      label="Mois"
      onChange={e => setMonth(e.target.value)}
      size="small"
    >
      {EracheMonths.map((m, idx) => (
        <MenuItem key={m} value={idx + 1}>{m}</MenuItem>
      ))}
    </Select>
  </FormControl>
  <FormControl size="small" sx={{ minWidth: 100 }}>
    <TextField
      label="Année"
      type="number"
      inputProps={{ min: 0 }}
      value={year}
      onChange={e => setYear(e.target.value)}
      size="small"
    />
  </FormControl>
</InputRow>


        <CalendarName>Date IRL correspondante :</CalendarName>
        <Result>
          {irlDate}
          <CopyButton onClick={handleCopy} buttonColor={buttonColor}>
            {buttonText}
          </CopyButton>
        </Result>
      </ConverterContainer>
    </Container>
  );
};

const ConverterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
`;

const InputRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
    width: 100%;
    align-items: stretch;
  }
`;

const Result = styled.div`
  margin-top: 10px;
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  align-items: center;
  min-width: 40vw;
  justify-content: space-between;
  @media (max-width: 768px) {
    min-width: 60vw;
    flex-direction: column;
    align-items: center;
  }
`;

const CopyButton = styled.button`
  margin-left: 10px;
  margin-right: 0;
  padding: 5px 10px;
  background-color: ${(props) => props.buttonColor || "var(--accent)"};
  color: #13110e;
  border: 1px solid var(--accent);
  border-radius: var(--radius-md);
  min-width: 100px;
  cursor: pointer;
  &:hover {
    background-color: var(--accent-hover);
    border-color: var(--accent-hover);
    box-shadow: 0 0 0 3px var(--accent-bg);
  }
  @media (max-width: 768px) {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 1.2em;
    &:active {
      background-color: var(--accent-hover);
    }
    min-width: 30vw;
  }
`;

const CalendarName = styled.div`
  margin-top: 20px;
  font-size: 1.2em;
`;

export default EracheToIRLConverter;
